<template>
  <div>
    <div class="star-holder">
        <template v-for="star in stars">
            <i v-if="star === 'f'" class="fas fa-star"></i>
            <i v-if="star === 'h'" class="fas fa-star-half-o"></i>
            <i v-if="star === 'e'" class="far fa-star unrated"></i>
        </template>
    </div>
    
    <div>
      {{ rating + '/' + max }}
    </div>
  </div>
</template>
<script>
  export default {
    props: ['max', 'rating'],
    computed: {
        stars() {
            if (this.max === 0 || this.rating === 0) return 0;
    
            let stars = [];
            let percentage = (this.rating / this.max) * 100;
            
            for (let i = 1; i <= 5; i++) {
                let fullSup = i*20;
                let fullInf = i*20 - 10;

                let halfSup = i*20 - 10;
                let halfInf = (i-1)*20;

                if( (percentage >= fullSup) || ( percentage <= fullSup && percentage >= fullInf ) ) {
                    stars.push('f');
                } else if ( percentage <= halfSup && percentage >= halfInf ) {
                    stars.push('h');
                } else {
                    stars.push('e');
                }
            }

            return stars;
        }
    }
  }
</script>
<style lang="scss">
.star-holder {
    display: block;
    clear: both;

    i {
        position: relative;
        color: #fdb92c;
    }

    .fa-star-half-o, .fa-star {
        color: #ffab00;
        font-weight: 900;
    }
    
    .rated{
        color: #ffab00;
        cursor: pointer;
    }

    .unrated{
        color: #757575;
        cursor: pointer;
    }

    .fa-star-half-o:before {
        content: "\f005";
    }
    
    .fa-star-half-empty:after, 
    .fa-star-half-full:after, 
    .fa-star-half-o:after {
        content: "\f005";
        transform: rotateY(-180deg);
        display: inline-block;
        left: 5px;
        position: absolute;
        top: 0;
        color: #757575;
        overflow: hidden;
        width: 10px;
    }    
}
</style>


// WEBPACK FOOTER //
// src/views/Results/Rating.vue